export const ListOfAssets = ({ fill }) => {
  return (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4511 4.33333H10.8333V2.73C10.8333 2.42667 10.6167 2.16666 10.3133 2.16666H8.66667V0.563335C8.66667 0.260001 8.45 0 8.14667 0H0.563333C0.259999 0 0 0.260001 0 0.563335V8.14667C0 8.45 0.259999 8.66667 0.563333 8.66667H2.16667V10.3133C2.16667 10.6167 2.42667 10.8333 2.73 10.8333H4.33333V12.4511C4.33333 12.7544 4.57889 13 4.88222 13H12.4656C12.7689 13 13.0144 12.7544 13.0144 12.4511V4.88222C13 4.57889 12.7544 4.33333 12.4511 4.33333ZM1.08333 7.58333V1.08333H7.58334V7.58333H1.08333ZM3.25 9.75V8.66667H8.14667C8.45 8.66667 8.66667 8.45 8.66667 8.14667V3.25H9.75V9.75H3.25ZM11.9167 11.9167H5.41667V10.8333H10.3133C10.6167 10.8333 10.8333 10.6167 10.8333 10.3133V5.41667H11.9167V11.9167Z"
        fill={fill}
      />
    </svg>
  );
};
